/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TCNewCompany = {
    /**
     * Client type - simplified as string
     */
    clientType?: TCNewCompany.clientType;
    name?: string | null;
    description?: string | null;
    tenantId: string;
    sector?: string | null;
};
export namespace TCNewCompany {
    /**
     * Client type - simplified as string
     */
    export enum clientType {
        GENERAL = 'GENERAL',
        REAL_ESTATE = 'REAL_ESTATE',
    }
}

